var map = {
	"app/about/about.module.ngfactory": [
		"CefC",
		0,
		6
	],
	"app/disclaimer/disclaimer.module.ngfactory": [
		"HuIO",
		0,
		5
	],
	"app/feedback/feedback.module.ngfactory": [
		"IgTG",
		0,
		4
	],
	"app/how-to/how-to.module.ngfactory": [
		"7kTi",
		0,
		3
	],
	"app/play/play.module.ngfactory": [
		"zKft",
		0,
		2
	],
	"app/rec/rec.module.ngfactory": [
		"FWr3",
		0,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Jnfr";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = Jnfr
// module chunks = 8